module.exports = __webpack_public_path__ + "static/media/academy-one-rev.93ca4a53.png";